export const message = {
  top: {
    nav1: "トップ",
    nav2: "会社紹介",
    nav3: "ホテル · 旅館",
    nav3Sub: "宿泊事業に専念し、安心で快適な滞在をご提供します。",
    nav4: "日本旅行と投資",
    nav4Sub:
      "日本への投資、越境貿易などのビジネスニーズに対して、幅広いコンサルサービスを提供します。",
    nav5: "デジタリマーケティングとIT開発",
    nav5Sub:
      "中国市場を開拓する企業にネット広告などのデジタルマーケティングをワンストップで提供します。",
    nav6: "お問い合わせ",
  },
  bottom: {
    lang1: "简体中文",
    lang2: "日本語",
    companyName: "盤古日本株式会社",
    emailLabel: "メール：",
    address: "住所：東京都港区高輪4-6-10-103",
    office: "品川OFFICE：東京都港区高輪4-6-10-103",
    copyText: "著作権所有",
    privacy: "プライバシーポリシー",
    privacyPolicy: "個人情報保護方針",
    supportText: "技術的サポート",
    supportCompany: "盤古広告",
  },
  home: {
    title: "宿泊施設運営のプロフェッショナルを目指して",
    titleLine1: "宿泊施設運営の",
    titleLine2: "プロフェッショナルを目指して",
    subTitleLine1: "旅館・ホテル・民泊を通じて、",
    subTitleLine2: "快適で安心できる宿泊体験をご提供します。",
    subTitle:
      "旅館・ホテル・民泊を通じて、快適で安心できる宿泊体験をご提供します。",
    btnText: "詳しく見る",
  },
  intro: {
    title: "会社紹介",
    subTitle: "宿泊事業に専念し、安心で快適な滞在をご提供します",
    more: "もっと",
    type1: {
      title: "心を込めたおもてなしで、日本の旅をより特別に",
      company: "心を込めたおもてなしで",
      desc: "ホテル・旅館運営の専門企業として、 施設管理からゲスト対応まで一貫したサービスを提供しています。 多言語対応と細やかなおもてなしを大切にし、 国内外のお客様に安心・快適な宿泊体験をお届けします。",
    },
    type2: {
      title: "BANKO NIHON",
      company: "盤古日本株式会社",
      desc: "盤古日本株式会社は2020年に東京で設立され、ホテル・旅館・宿泊施設の運営管理に特化しています。世界中からお越しのお客様に安心・快適な宿泊体験を提供するため、多言語サービスときめ細やかなおもてなしを通じ、地域の魅力と高品質なサービスを兼ね備えた宿泊施設の創出に努めています。国内外のお客様に「また泊まりたい」と思っていただける施設を目指し、安心・快適・高品質な滞在をお届けします。",
    },
    feature1: {
      title: "専門運営",
      desc1: "多様な施設タイプに対応",
      desc2: "豊富な運営経験を保有",
    },
    feature2: {
      title: "安心 · 安全",
      desc1: "法令を厳格に遵守",
      desc2: "リスク管理体制の整備と安心の運営体制",
    },
    feature3: {
      title: "多言語 · 多文化対応",
      desc1: "多言語サービスを提供",
      desc2: "世界各地からのお客様を温かくお迎え",
    },
    feature4: {
      title: "24時間サポート",
      desc1: "安心と利便性のために",
      desc2: "24時間体制のサポートサービスを提供",
    },
  },
  manager: {
    title: "私たちの想い",
    subTitle: "宿泊事業に専念し、安心で快適な滞在をご提供します。",
    type1: {
      title: "品川",
      subTitle: "pangoo品川",
      desc: "港区高輪に位置し、品川駅まで徒歩約6分。閑静で安全な高級住宅街にあり、品川駅からはJR 8路線を利用でき、交通の便が良い立地です。大阪・名古屋など主要都市へも新幹線でアクセス可能。羽田空港・成田空港へも直通で行けます。明るく広い室内空間を整え、清潔で快適な滞在をお届けします。",
      room: "部屋数：全35室、最大2〜3名収容",
      addrTitle: "住所",
      addr: {
        addr1: "東京都港区高輪4-6-10",
        addr2: "东京都港区高轮4-6-10",
        addr3: "Takanawa 4-6-10, Minato-ku, Tokyo, Japan",
      },
      trafficTitle: "交通",
      traffic: {
        traffic1: "JR「品川」駅 徒歩約6分",
        traffic2: "都営浅草線「高輪台」駅 徒歩約10分",
        traffic3: "JR「東京」駅：京浜東北線で約20分",
        traffic4: "「渋谷」駅：山手線で約23分",
        traffic5: "「東京タワー」：都営浅草線で約30分",
        traffic6: "ホテルから徒歩4分でコンビニに到着",
      },
      linkList: [
        {
          name: "booking予約",
          href: "https://www.booking.com/hotel/jp/biyurogao-lun.zh-cn.html",
        },
        {
          name: "airbnb予約",
          href: "https://zh.airbnb.com/rooms/658157619198664961",
        },
      ],
    },
    type2: {
      title: "恵比寿レッド",
      subTitle: "pangoo恵比寿レッド",
      desc: "恵比寿は、東京で最も人気のあるエレガントな高級住宅街であり、近くには素晴らしいレストランもたくさんあります。恵比寿横丁は居酒屋が立ち並び、夜になると非常に賑やかです。どの居酒屋も個性的なので、飲み比べが最高です。",
      room: "部屋数：戸建て1軒、2-4人収容可能",
      addrTitle: "アドレス",
      addr: {
        addr1: "東京都渋谷区恵比寿3-9-3",
        addr2: "东京都涩谷区惠比寿3-9-3",
        addr3: "Ebisu3-9-3, Shibuya-ku, Tokyo, Japan",
      },
      traffic: {
        traffic1: "JR「惠比寿」駅から徒歩7分",
        traffic2: "東京メトロ日比谷線「惠比寿」駅から徒歩8分",
        traffic3: "羽田空港：モノレールとJR線に乗り、約42分で到着",
        traffic4: "成田空港：京成スカイライナーと山手線に乗り、約75分で到着",
        traffic5: "また、民宿から徒歩２分はすぐコンビニストアに到着",
      },
      linkList: [
        {
          name: "booking予約",
          href: "https://www.booking.com/hotel/jp/the-villa-ebisuhui-bi-shou-yi-tu-bu-8fen-jing-kanazhu-zhai-di.zh-cn.html",
        },
        {
          name: "airbnb予約",
          href: "https://www.airbnb.jp/rooms/1305625660777542372",
        },
      ],
    },
    type2b: {
      title: "恵比寿ブルー",
      subTitle: "pangoo恵比寿ブルー",
      desc: "恵比寿は、東京で最も人気のあるエレガントな高級住宅街であり、近くには素晴らしいレストランもたくさんあります。恵比寿横丁は居酒屋が立ち並び、夜になると非常に賑やかです。どの居酒屋も個性的なので、飲み比べが最高です。",
      room: "部屋数：戸建て1軒、2-4人収容可能",
      addrTitle: "アドレス",
      addr: {
        addr1: "東京都渋谷区恵比寿3-9-3",
        addr2: "东京都涩谷区惠比寿3-9-3",
        addr3: "Ebisu3-9-3, Shibuya-ku, Tokyo, Japan",
      },
      traffic: {
        traffic1: "JR「惠比寿」駅から徒歩7分",
        traffic2: "東京メトロ日比谷線「惠比寿」駅から徒歩8分",
        traffic3: "羽田空港：モノレールとJR線に乗り、約42分で到着",
        traffic4: "成田空港：京成スカイライナーと山手線に乗り、約75分で到着",
        traffic5: "また、民宿から徒歩２分はすぐコンビニストアに到着",
      },
      linkList: [
        {
          name: "booking予約",
          href: "https://www.booking.com/hotel/jp/the-villa-ebisuhui-bi-shou-yi-tu-bu-8fen-jing-kanazhu-zhai-di-blue.zh-cn.html",
        },
        {
          name: "airbnb予約",
          href: "https://www.airbnb.jp/rooms/1304800134346302899",
        },
      ],
    },
    type3: {
      title: "箱根-満来",
      subTitle: "pangoo箱根-満来",
      desc1:
        "箱根は神奈川県西部に位置し、豊かな温泉資源で知られる日本有数のリゾート地です。満来は箱根温泉の一等地・仙石原に佇む宿泊施設で、国内外のお客様に安心で快適な滞在をお届けします。",
      desc2:
        "満来別荘は箱根温泉の一等地・仙石原に位置し、2122㎡の庭園と良質な温泉を備えた和風別荘。床暖房など設備も整い、四季を通じてゆったりとした時間をお過ごしいただけます。",
      room: "部屋数：全7室、最大15人収容",
      addrTitle: "住所",
      addr: {
        addr1: "神奈川県足柄下郡箱根町仙石原1285-358",
        addr2: "神奈川県足柄下郡箱根町仙石原1285-358",
        addr3:
          "1285-358 Sengokuhara, Hakone, Ashigarashimo District, Kanagawa 250-0631",
      },
      traffic: {
        traffic1: "箱根バス「小塚入口」駅：徒歩4分",
        traffic2: "羽田空港：京急空港線/京急本線ー新幹線ー箱根バス85分",
        traffic3: "成田空港：JR成田エクスプレスー新幹線ー箱根バス105分",
        traffic4: "東京駅：新幹線ー箱根バス75分",
        traffic5: "新宿駅：小田急ロマンスカーー箱根バス100分",
      },
      linkList: [
        {
          name: "booking予約",
          href: "https://www.booking.com/hotel/jp/mi-mi-hua-yuan-xiang-gen-si-tang-wen-quan-du-jia-bie-shu.zh-cn.html",
        },
        {
          name: "airbnb予約",
          href: "https://www.airbnb.jp/rooms/753179090454896784",
        }
      ],
    },
    /* 以下物业 Tab 已下线，保留文案备查
    type4: {
      title: "箱根-ローズの城",
      subTitle: "pangoo箱根-ローズの城",
      desc1:
        "【ローズの城】は仙石原温泉の中心部にあり、ススキ草原から徒歩2分。",
      desc2:
        "外観は赤と緑のレンガ造りの壁で、レトロでロマンチックな建物です.良質仙石原源泉温泉、男女別に池につかる。家の前の空き地は無料で駐車でき、裏庭には庭の景観がある。",
      room: "部屋数：全室7室、最大16人収容可能",
      addrTitle: "アドレス",
      addr: {
        addr1: "神奈川県足柄下郡箱根町仙石原1246-130",
        addr2:
          "1246-130 Sengokuhara, Hakone, Ashigarashimo District, Kanagawa 250-0631",
      },
      traffic: {
        traffic1: "箱根バス「仙石原高原駅」駅：徒歩2分",
        traffic2: "羽田空港：京急空港線/京急本線ー新幹線ー箱根バス100分",
        traffic3: "成田空港：JR成田エクスプレスー新幹線ー箱根バス150分",
        traffic4: "東京駅：新幹線ー箱根バス85分",
        traffic5: "新宿駅：小田急ハイウェイバス135分",
      },
      linkList: [
        {
          name: "airbnb予約",
          href: "https://www.airbnb.jp/rooms/868354830467219526?source_impression_id=p3_1686637224_EIKnTJiILpf4RHEI",
        },
        { name: "booking予約", href: "https://www.booking.com/Share-AQUbyzi" },
      ],
    },
    type5: {
      title: "伊豆",
      subTitle: "pangoo伊豆",
      desc1:
        "城ヶ崎海岸は伊東エリアを代表する観光名所。サスペンスドラマのロケ地としても有名です。",
      desc2:
        "断崖絶壁にかかる吊り橋、絶景パノラマを望める灯台など、見どころも満載！",
      desc3: "【ピースムン】伊東温泉別荘は城ヶ崎海岸まで徒歩3分。",
      desc4:
        "富戸みなとゴルフパークまで徒歩3分,富戸みなとゴルフパークまで徒歩3分。",
      room: "部屋数：全室6室、最大16人収容可能",
      addrTitle: "アドレス",
      addr: {
        addr1: "静岡県伊東市富戸842-173",
        addr2: "842-173 Futo, Itō, Shizuoka 413-0231",
      },
      traffic: {
        traffic1: "お車で",
        traffic2: "東京方面 東名高速厚木ICから約2時間",
        traffic3: "愛知方面 長泉沼津ICから約1時間30分",
        traffic4: "徒歩：伊豆急行線城ヶ崎海岸駅から徒歩約35分",
      },
      linkList: [
        {
          name: "airbnb予約",
          href: "https://www.airbnb.jp/rooms/883693044329307885?source_impression_id=p3_1686637197_gQGfFttcIIW31PRZ",
        },
        { name: "booking予約", href: "https://www.booking.com/Share-zO7Srw" },
      ],
    },
    type6: {
      title: "沖縄",
      subTitle: "pangoo沖縄",
      desc1:
        "恩納和風ホテルは沖縄本島のなかでも便利な恩納に位置しており、観光名所や食事処に近い場所にあります。",
      desc2: "和のくつろぎを感じさせる畳を全室にご用意しております。",
      desc3:
        "恩納海浜公園ナビービーチまで200m、万座ビーチまで700m、ムーンビーチまで8km、那覇空港まで39kmです。",
      room: "部屋数：全室27室、各2-3人収容可能",
      addrTitle: "アドレス",
      addr: {
        addr1: "沖縄県恩納村字恩納398-3",
        addr2: "398-3 Onna, Kunigami District, Okinawa 904-0411",
      },
      traffic: {
        traffic1: "車・タクシー：",
        traffic2:
          "那覇空港より高速道路利用、屋嘉IC まで約50分、屋嘉ICより国道58 号線を北向け約10分。",
        traffic3: "駐車場：無料。",
        traffic4: "路線バス：",
        traffic5:
          "那覇バスターミナルから約2時間、万座ビーチ前バス停下車後、徒歩2分。",
      },
      linkList: [
        { name: "airbnb予約", href: "https://www.airbnb.jp/users/show/510409901" },
        { name: "booking予約", href: "https://www.booking.com/Share-6JG7Se2" },
      ],
    },
    */
  },
  investment: {
    title: "日本旅行と投資",
    subTitle: "越境貿易などの幅広いコンサルサービ",
    type1: {
      title: "旅行と居住",
      subTitle: "日本でセカンドハウスのお探し",
      desc: "日本住宅購入基礎コンサルティング大手建設会社のマンション、中古マンション、一戸建てから、現地調査、契約、購入後のリフォーム・入居、物件の納入・資産税納付まで、あらゆる面で対応しています。",
    },
    type2: {
      title: "マンション投資",
      subTitle: "賃貸の運用管理サービスを提供",
      desc: "通常のマンションを購入し賃貸に出す場合、お客様の利回りや資産保有期間に対する要求に応じて、価値維持と収益を両立できる資産をご提案いたします。",
    },
    type3: {
      title: "民宿ホテルの投資",
      subTitle: "ホテルの経営資格とブラントフランチャイズサービスを提供",
      desc: "民宿やホテルとして運営可能な物件を購入します。物件の選定・リノベーション、資格取得、オンラインOTA販売、オフライン運営、ブラントフランチャイズサービスを提供いたします。",
    },
    type4: {
      title: "移民",
      subTitle: "ビザの取得",
      desc: "投資をベースに、日本の経営管理ビザの取得や、将来の永住権申請のニーズに合わせ、投資計画や資本計画をゼロから設計いたします。合理的なプランで実収入を得たうえでビザを取得できるように支援いたします。",
    },
    type5: {
      title: "+α",
      subTitle: "その他サービス ",
      desc: "日本での生活、ビジネスマッチング、留学、医療などの相談やコンサルサービスを提供いたします。",
    },
  },
  development: {
    title: "デジタリマーケティングとIT開発",
    subTitle: "インターネット広告とIT技術サービス",
    btnText: "すぐ問い合わせる",
    type1: {
      title: "検索エンジン",
      desc1: "95%のインターネットユーザーをカバーすることが可能であり",
      desc2: "キーワードによってターゲットユーザーを絞り込む",
      desc3: "従量課金制であり、クリックがない場合、費用が発生しません",
      desc4: "",
    },
    type2: {
      title: "信息流",
      desc1:
        "いち早くブランド情報をユーザに届けるクリエイティブな形式を活用して",
      desc2: "大量なインプレッション数に達成します",
      desc3: "",
    },
    type3: {
      title: "ECサイト",
      desc1: "ネットワークインフラを提供します。",
      desc2: "決済プラットフォームなどのシェアリソースを提供します。",
      desc3: "マーケティングを削減することで収益を増やします。",
      desc4: "",
    },
    type4: {
      title: "SaaS业务",
      desc1: "“強力なデジタル技術に基づき”",
      desc2: "オンデマンドのインターネットマーケティングサービスを提供し",
      desc3: "企業のマーケティング力を大幅に強化します",
    },
    type5: {
      title: "技術サービス",
      desc1: "業務向けのソリューションを提供します。",
      desc2:
        "お客様は当該の業界の変革をリードできるように、お客様の組織のデジタルトランスフォーメーションを支援いたします",
      desc3: "",
      desc4: "",
    },
  },
  contact: {
    title: "お問い合わせ",
    btnText: "送信する",
    change: "1枚交換します",
    form: {
      name: "名前",
      nameError: "'名前'を入力してください",
      email: "メールアドレス",
      emailError: "'メールボックス'を入力してください",
      companyName: "会社名",
      companyNameError: "「会社名」を入力してください",
      mobile: "電話番号",
      mobileError: "「電話」と入力してください",
      consultText: "お問い合わせ内容",
      consultTextError: "'コンテンツ'を入力してください",
      code: "検証コート",
      codeError: "'確認コード' が正しくありません",
    },
  },
};
